import {Injectable} from '@angular/core';
import {Observable, Subject, BehaviorSubject} from "rxjs";
import {AuthInfo} from "./auth-info";
import {UserService} from "../services/user/user.service";
import { AngularFireAuth } from "angularfire2/auth";
import {InvitationCode} from "../model/invitation-code";
import {AngularFireDatabase} from "angularfire2/database";

@Injectable()
export class AuthService {

  public user;
  private isAnAdmin;

  static UNKNOW_USER = new AuthInfo(null,null,null,null,null);

  public authInto$:BehaviorSubject<AuthInfo> = new BehaviorSubject<AuthInfo>(AuthService.UNKNOW_USER);

  public authorized$:BehaviorSubject<boolean> = new BehaviorSubject(false);

  public verified:BehaviorSubject<boolean> = new BehaviorSubject(false);
  private sdkDb: firebase.database.Reference

  private showMenu = new Subject<any>()


  constructor(

    private userservice: UserService,
    private db:AngularFireDatabase,
    public afAuth: AngularFireAuth



  )
  {

    this.sdkDb = db.app.database().ref();
    this.user = afAuth.authState;


  }


  getCode(codeID:string):Observable<any>{

    const codeRecord$ = this.db.list("invitation_codes",{
      query:{
        orderByChild: 'code',
        equalTo: codeID
      }
    })
      .map (results => results)
      // .do(console.log);

    return codeRecord$

  }

  public markCodeAsUsed(codeRecord:InvitationCode):Observable<any>{
    // console.log('Code Record');
    // console.log(codeRecord);
    let codeRecorId = codeRecord.$key;
    const codeRecordToSave = Object.assign({},codeRecord);
    delete(codeRecordToSave.$key);
    let dataToSave = {};
    dataToSave["invitation_codes/"+codeRecorId] = codeRecordToSave;
    return this.firebaseUpdate(dataToSave);

  }


  anonymously(): Observable<any>{

    const subject = new Subject<any>();
    this.afAuth.auth.signInAnonymously()
      .then(res => {
          this.notAnValidUser();
          subject.next(res);
          subject.complete();
      },
      err =>{
        subject.error(err);
        subject.complete();
      });
    return subject.asObservable();

  }

  createInviteCode(inviteCode:InvitationCode):Observable<any>{

    const codeToSave = Object.assign({}, inviteCode)

    // console.info(code);

    const newCodeleKey = this.sdkDb.child('invitation_codes').push().key;

    let dataToSave = {};

    dataToSave["invitation_codes/"+newCodeleKey] = codeToSave;

    return this.firebaseUpdate(dataToSave);

  }

  private firebaseUpdate(dataToSave: {}) {

    const subject = new Subject();

    this.sdkDb.update(dataToSave)
      .then(
        val =>{
          subject.next(val);
          subject.complete();

        },
        err =>{
          subject.error(err);
          subject.complete();

        }
      );

    return subject.asObservable();

  }


  createUser(email: string, password: string, ownername: string):Observable<any>{
  const subject = new Subject<any>();
  this.afAuth.auth.createUserWithEmailAndPassword(email,password).then(res => {
    this.afAuth.authState.subscribe( user => {
        this.fillOutAurhInfo();
        subject.next(user);
        subject.complete();
    },
    err =>{
      // console.log(err);
      subject.error(err);
      subject.complete();

    });
  }).catch( (ex) => {
          // console.error('Error creating users', ex)
          subject.error(ex);
          subject.complete();

    })

    return subject.asObservable();
  };


  sendVerificationEmmail():Observable<any>{
    // console.log("Sending Email Verification! ");
    const subject = new Subject<any>();
    let currUser:any = this.afAuth.auth.currentUser;
    currUser.sendEmailVerification().then(res => {
        subject.next(res);
        subject.complete();
      },
      err =>{
        // console.log(err);
        subject.error(err);
        subject.complete();
      });
    return subject.asObservable();
  }



  updateProfileName(ownername):Observable<any>{
    const subject = new Subject<any>();
    this.afAuth.auth.currentUser.updateProfile({displayName:ownername,photoURL:''}).then(res => {
        subject.next(res);
        subject.complete();
      },
      err =>{
        subject.error(err);
        subject.complete();
      });
    return subject.asObservable();
  }


  resetPassword(email: string): Observable<any> {
    const subject = new Subject<any>();
    this.afAuth.auth.sendPasswordResetEmail(email).then(res => {
        subject.next(res);
        subject.complete();
      },
      err =>{
        subject.error(err);
        subject.complete();
      });
    return subject.asObservable();
  }

  onUserChange() : Observable<any> {
    // console.log("On User Change!");
    const subject = new Subject<any>();
    // this.isAnAdmin = this.isAdmin();
    if (!this.afAuth.auth.currentUser){
      this.afAuth.auth.onAuthStateChanged((user) => {
        // console.log(user);
        this.fillOutAurhInfo();
          subject.next(user);
          subject.complete();
        });
    }
    return subject.asObservable();
  }


  fillOutAurhInfo(){
    // console.log("Filling out User!");
    const authState$ = this.afAuth.authState;
    authState$
      .subscribe(user => {
         // console.log(user);
        this.user = user;
        if (this.user !== null){
          if (this.user.isAnonymous === false){
            this.afAuth.auth.currentUser.reload();
            let thisUid = this.user.uid;
            let thisDispName = this.user.displayName;
            let thisEmailVerified = this.user.emailVerified;
            let thisVerifiedDisp = this.verifiedDisp();
            let thisEmail = this.user.email;
            const authInfo = new AuthInfo(thisUid,thisDispName,thisEmailVerified,thisVerifiedDisp,thisEmail);
            this.isAnAdmin = this.isAdmin();
            let admin = this.isAnAdmin;
            this.authInto$.next(authInfo);
            // console.log("uid :" + thisUid +" Email Verified :" + thisEmailVerified +" Admin :"+ admin);
            this.authorized$.next(thisUid && thisEmailVerified);
            this.verified.next(this.user.emailVerified);
          } else {
            this.notAnValidUser();
          }
        } else {
          this.notAnValidUser();
        }
      });
  }

  notAnValidUser(){
    this.isAnAdmin = false;
    this.authInto$.next(AuthService.UNKNOW_USER);
    this.authorized$.next(false);
  }

  login(email: string, password: string):Observable<any> {
    // console.log("Login!");
    const subject = new Subject<any>();
    this.afAuth.auth.signInWithEmailAndPassword(email,password).then(res => {
        this.afAuth.authState.subscribe( user => {
            this.fillOutAurhInfo();
            subject.next(user);
            subject.complete();
          },
          err =>{
            subject.error(err);
            subject.complete();
          });
        },
      err =>{
        subject.error(err);
        subject.complete();
      });
    return subject.asObservable();
  }

  logout() {
    this.notAnValidUser();
    this.authInto$.next(AuthService.UNKNOW_USER);
    this.authorized$.next(null);
    this.afAuth.auth.signOut();
  }

  getUid():string {
    return this.authInto$.value.$uid;
  }

  getDispName():string {
    return this.authInto$.value.userdisplayName;
  }


  emailVerified():boolean {
    return  this.afAuth.auth.currentUser.emailVerified;
  }



  verifiedDisp():string {
    let dispMessage = "";
    let verified = this.afAuth.auth.currentUser.emailVerified;
    if (verified){
      this.authInto$.value.verified = verified;
      dispMessage = "Verified";
      this.verified.next(true);
    } else {
      dispMessage = "Not Verified";
    }

    return dispMessage;
  }

  isLoggedIn():boolean{
    let thisUid = (this.afAuth.auth.currentUser.uid);
       if (thisUid) {
         this.authInto$.value.$uid = thisUid;
           return true
         } else {
           return false
       }
  }

  getEmailAdd():string {
    return this.afAuth.auth.currentUser.email;;
  }

  isAdmin():boolean{
    this.userservice.isAdmin(this.afAuth.auth.currentUser.uid)
      .subscribe(imAdmin => {
      });
    return true
  }

  getUserKey():Observable<any> {
    return Observable.create(obserber => {
      this.userservice.getUser(this.getUid())
        .subscribe((user) => {
          obserber.next(user.$key);
          obserber.complete();
        });
    })
  }


  setShow(setTo:boolean){
    this.showMenu.next(setTo)
  }



  getShowMenu():Observable<any> {
    return this.showMenu.asObservable();

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/security/auth.service.ts